<template>
	<div>
		<v-dialog
			max-width="600px"
			fullscreen
			hide-overlay
			v-model="showDialog"
		>
			<div
				class="header"
				:style="{
					backgroundColor: themeInputColor,
					position: 'fixed'
				}"
			>
				<v-btn
					fab
					flat
					icon
					class="top-left-align pa-0 ma-0 z-index--2"
					@click="goBack"
				>
					<v-icon color="#FFF">arrow_back</v-icon>
				</v-btn>
				Visit History
			</div>
			<div style="margin-top: 65px;">
				<div v-if="processStep === 1">
					<v-select
						:items="selectDateOptions"
						label="Select Date"
						hide-details
						class="body-1 text-field-wrapper py-4"
						v-model="dateOption"
						@change="val => handleDropdownChange('date', val)"
					></v-select>
					<v-layout
						class="justify-space-between"
						v-if="dateOption === 'Custom' && showDialog"
					>
						<v-flex xs12 sm6 md4>
							<v-menu
								v-model="menu1"
								:close-on-content-click="false"
								:nudge-right="40"
								lazy
								transition="scale-transition"
								offset-y
								full-width
								min-width="290px"
							>
								<template v-slot:activator="{ on }">
									<v-text-field
										v-model="startTime"
										label="Start Date"
										prepend-icon="event"
										readonly
										v-on="on"
									></v-text-field>
								</template>
								<v-date-picker
									v-model="startTime"
									@input="menu1 = false"
									@change="val => handleTimeChange(true, val)"
								></v-date-picker>
							</v-menu>
						</v-flex>
						<v-flex xs12 sm6 md4>
							<v-menu
								v-model="menu2"
								:close-on-content-click="false"
								:nudge-right="40"
								lazy
								transition="scale-transition"
								offset-y
								full-width
								min-width="290px"
							>
								<template v-slot:activator="{ on }">
									<v-text-field
										v-model="endTime"
										label="End Date"
										prepend-icon="event"
										readonly
										v-on="on"
									></v-text-field>
								</template>
								<v-date-picker
									v-model="endTime"
									@input="menu1 = false"
									@change="
										val => handleTimeChange(false, val)
									"
								></v-date-picker>
							</v-menu>
						</v-flex>
					</v-layout>
					<v-card
						v-for="item in visitHistoryData.filter(
							data =>
								!isJeet11Executive ||
								data.visitorType === 'executive'
						)"
						:key="item.retailerId"
						class="mb-2 alignInColumn"
					>
						<div class="justify-space-around" style="display:flex">
							<div class="pa-2 alignInColumn">
								<div class="font-weight-bold mb-2">
									{{ item.retailerName || "-" }} (
									{{
										item.visitorType === "tsm"
											? "TSM"
											: "DSE"
									}}
									)
								</div>
								<div style="font-size:10px">
									Last visit on
									{{
										(item.visitTime &&
											new Date(item.visitTime)
												.toLocaleString()
												.substring(0, 17)) ||
											""
									}}
								</div>
							</div>
							<div class="pa-2">
								<v-btn
									color="primary"
									style="min-width: 150px;"
									@click="showRetail(item)"
									>View Details</v-btn
								>
							</div>
						</div>
					</v-card>
					<div v-if="!visitHistoryDataLength" class="text-xs-center">
						No Data
					</div>
					<div
						style="display: flex;justify-content: center"
						class="mb-2"
					>
						<v-icon
							v-if="offset"
							color="#000"
							style="cursor: pointer"
							@click="changeOffset('dec')"
							>chevron_left</v-icon
						><v-icon
							v-if="allRetailVisits.length === limit"
							color="#000"
							style="cursor: pointer"
							@click="changeOffset('inc')"
							>chevron_right</v-icon
						>
					</div>
				</div>
				<div class="container" v-else>
					<div class="proofDocument mb-2" style="font-size:12px">
						Business/Shop Photo Submitted on Visit
					</div>
					<img
						:src="retailerData.shopImage"
						alt
						class="mb-2 imageSize"
					/>
					<div class="proofDocument mb-2" style="font-size:12px">
						Business/Shop Photo Submitted by
						{{ retailerData.visitorType === "tsm" ? "TSM" : "DSE" }}
					</div>
					<img
						:src="retailerData.tsmShopImage"
						alt
						class="mb-2 imageSize"
					/>
					<div class="proofDocument mb-2">Retailer Shop Address</div>
					<v-card class="addressBox font-weight-bold mb-2"
						><div>{{ retailerData.address }}</div>
						<div>
							{{ retailerData.state }}, {{ retailerData.city }}
						</div>
						<div>Pincode: {{ retailerData.pincode }}</div></v-card
					>
					<v-btn
						@click="
							openGoogleMap(
								`https://maps.google.com?q=${retailerData.latitude},${retailerData.longitude}`
							)
						"
						>View location on Maps
					</v-btn>
					<div class="proofDocument mb-2">
						Submitted Documents
					</div>
					<v-card class="pdfCard" v-if="retailerData.addressProof">
						<div class="ma-2">
							{{
								retailerData.addressProof[0].docType === "GST"
									? "GST Certificate"
									: "Current Address Proof"
							}}
						</div>
						<pdf
							:src="{
								url: retailerData.addressProof[0].url
							}"
							:key="retailerData.addressProof[0].url"
							:resize="true"
							:scale.sync="scale"
							style="width:40%;"
						>
							<template slot="loading">
								loading content here...
							</template>
						</pdf>
						<v-layout class="white" style="justify-content:end">
							<v-btn @click="downloadPdf" color="success"
								>Download</v-btn
							>
						</v-layout>
					</v-card>
				</div>
			</div>
		</v-dialog>
		<div v-if="!showDialog">
			<v-select
				:items="tsmList"
				label="Select TSM"
				item-text="retailerName"
				item-value="userId"
				hide-details
				class="body-1 text-field-wrapper py-4"
				@change="val => handleDropdownChange('tsm', val)"
				v-if="!isJeet11Executive && !isJeet11TSM"
			></v-select>
			<v-select
				:items="dseList"
				label="Select DSE"
				item-text="retailerName"
				item-value="userId"
				hide-details
				v-model="selectedDse"
				class="body-1 text-field-wrapper py-4"
				@change="val => handleDropdownChange('dse', val)"
				v-if="!isJeet11Executive"
			></v-select>
			<v-select
				:items="selectDateOptions"
				label="Select Date"
				hide-details
				class="body-1 text-field-wrapper py-4"
				v-model="dateOption"
				@change="val => handleDropdownChange('date', val)"
			></v-select>
			<v-layout
				class="justify-space-between"
				v-if="dateOption === 'Custom'"
			>
				<v-flex xs12 sm6 md4>
					<v-menu
						v-model="menu1"
						:close-on-content-click="false"
						:nudge-right="40"
						lazy
						transition="scale-transition"
						offset-y
						full-width
						min-width="290px"
					>
						<template v-slot:activator="{ on }">
							<v-text-field
								v-model="startTime"
								label="Start Date"
								prepend-icon="event"
								readonly
								v-on="on"
							></v-text-field>
						</template>
						<v-date-picker
							v-model="startTime"
							@input="menu1 = false"
							@change="val => handleTimeChange(true, val)"
						></v-date-picker>
					</v-menu>
				</v-flex>
				<v-flex xs12 sm6 md4>
					<v-menu
						v-model="menu2"
						:close-on-content-click="false"
						:nudge-right="40"
						lazy
						transition="scale-transition"
						offset-y
						full-width
						min-width="290px"
					>
						<template v-slot:activator="{ on }">
							<v-text-field
								v-model="endTime"
								label="End Date"
								prepend-icon="event"
								readonly
								v-on="on"
							></v-text-field>
						</template>
						<v-date-picker
							v-model="endTime"
							@input="menu1 = false"
							@change="val => handleTimeChange(false, val)"
						></v-date-picker>
					</v-menu>
				</v-flex>
			</v-layout>
			<v-card
				v-for="item in shops"
				:key="item.userId"
				class="mb-2 alignInColumn"
			>
				<div class="justify-space-between" style="display:flex">
					<div class="pa-2 alignInColumn">
						<div class="font-weight-bold mb-2">
							{{ item.retailerName || "-" }}
						</div>
						<div style="font-size:10px">
							Last visit on
							{{
								(item.visitTime &&
									new Date(item.visitTime)
										.toLocaleString()
										.substring(0, 17)) ||
									""
							}}
						</div>
					</div>
					<div class="pa-2">
						<v-btn
							color="primary"
							style="min-width: 150px;"
							@click="openPopup(item)"
							:disabled="!item.tsm && !item.executive"
							>View</v-btn
						>
					</div>
				</div>
				<div style="display:flex;justify-content: center;">
					<v-card
						class="alignInColumn px-2 py-1 mr-1"
						v-if="!isJeet11Executive"
						><div style="color: #00000073;">
							{{ isJeet11TSM ? "Your" : "TSM" }} Visits
						</div>
						<div class="text-xs-center">
							{{ item.tsm || "-" }}
						</div></v-card
					>
					<v-card class="alignInColumn px-2 py-1 ml-1"
						><div style="color: #00000073;">
							{{ isJeet11Executive ? "Your" : "DSE" }} Visits
						</div>
						<div class="text-xs-center">
							{{ item.executive || "-" }}
						</div></v-card
					>
				</div></v-card
			>
			<div style="display: flex;justify-content: center" class="mb-2">
				<v-icon
					v-if="offset"
					color="#000"
					style="cursor: pointer"
					@click="changeOffset('dec')"
					>chevron_left</v-icon
				><v-icon
					v-if="allRetailVisits.length === limit"
					color="#000"
					style="cursor: pointer"
					@click="changeOffset('inc')"
					>chevron_right</v-icon
				>
			</div>
		</div>
		<div v-if="isLoading" class="overlay">
			<v-progress-circular :indeterminate="true"></v-progress-circular>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import pdf from "pdfvuer";
import { THEME_INPUT_COLOUR } from "../constants";
import {
	FETCH_ALL_RETAIL_VISITS,
	GET_RETAILER_VISIT_HISTORY
} from "../../store/action-types";
import { __fileDownload } from "../../utils";

export default {
	name: "VisitHistory",
	data: () => ({
		tsmList: [],
		dseList: [],
		shops: [],
		selectDateOptions: [
			"This Month",
			"Last Month",
			"Last Three Months",
			"Custom"
		],
		dateOption: "This Month",
		selectedTsm: "",
		selectedDse: "",
		currentUserId: "",
		menu1: false,
		menu2: false,
		startTime: new Date().toISOString(),
		endTime: new Date().toISOString(),
		allRetailVisits: {},
		showDialog: false,
		themeInputColor: THEME_INPUT_COLOUR,
		processStep: 1,
		selectedShop: {},
		visitHistoryData: [],
		retailerData: {},
		isLoading: false,
		limit: 100,
		offset: 0,
		scale: "page-width",
		visitHistoryDataLength: 0
	}),
	mounted() {
		this.currentUserId = this.userId;
		this.fetchAllRetailVisits(this.currentUserId);
	},
	components: {
		pdf
	},
	computed: {
		...mapState({
			userId: state => state.auth.USERID
		}),
		...mapGetters({
			isJeet11Executive: "auth/isJeet11Executive",
			isJeet11TSM: "auth/isJeet11TSM"
		})
	},
	methods: {
		fetchAllRetailVisits(userId, startTime, endTime) {
			this.isLoading = true;
			this.setStartEndDate(startTime, endTime);
			this.$store
				.dispatch(FETCH_ALL_RETAIL_VISITS.dispatch, {
					limit: this.limit,
					offset: this.offset,
					userId,
					startTime:
						this.dateOption === "Custom"
							? new Date(this.startTime).toISOString()
							: this.startTime,
					endTime:
						this.dateOption === "Custom"
							? new Date(this.endTime).toISOString()
							: this.endTime
				})
				.then(data => {
					this.allRetailVisits = data.shops ? data : {};
					this.tsmList = this.allRetailVisits.tsm || this.tsmList;
					this.dseList =
						this.allRetailVisits.executive || this.dseList;
					this.shops = this.allRetailVisits.shops || [];
				})
				.catch(err => console.log(err))
				.finally(() => {
					this.isLoading = false;
				});
		},
		getRetailerVisitHistory(userId, startTime, endTime) {
			this.isLoading = true;
			this.setStartEndDate(startTime, endTime);
			this.$store
				.dispatch(GET_RETAILER_VISIT_HISTORY.dispatch, {
					limit: this.limit,
					offset: this.offset,
					userId,
					startTime:
						this.dateOption === "Custom"
							? new Date(`${this.startTime}:00:00`).toISOString()
							: this.startTime,
					endTime:
						this.dateOption === "Custom"
							? new Date(`${this.endTime}:23:59`).toISOString()
							: this.endTime
				})
				.then(data => {
					this.visitHistoryData = (data || []).filter(
						data =>
							!this.isJeet11Executive ||
							data.visitorType === "executive"
					);
					this.visitHistoryDataLength = this.visitHistoryData.length;
				})
				.catch(err => console.log(err))
				.finally(() => {
					this.isLoading = false;
				});
		},
		setStartEndDate(startTime, endTime) {
			const date = new Date();
			const currDate = date.toISOString();
			const currMonthStartDate = new Date(
				date.getFullYear(),
				date.getMonth(),
				1
			).toISOString();
			const lastMonthEndDate = new Date(
				date.getFullYear(),
				date.getMonth(),
				0,
				23,
				59
			).toISOString();
			const lastMonthStartDate = new Date(
				date.getFullYear(),
				date.getMonth() - 1,
				1
			).toISOString();
			const lastThreeMonthStartDate = new Date(
				date.getFullYear(),
				date.getMonth() - 3,
				1
			).toISOString();
			if (this.dateOption === "This Month") {
				this.startTime = currMonthStartDate;
				this.endTime = currDate;
			} else if (this.dateOption === "Last Month") {
				this.startTime = lastMonthStartDate;
				this.endTime = lastMonthEndDate;
			} else if (this.dateOption === "Last Three Months") {
				this.startTime = lastThreeMonthStartDate;
				this.endTime = lastMonthEndDate;
			} else {
				this.startTime = currDate.substring(0, 10);
				this.endTime = currDate.substring(0, 10);
			}
			if (startTime && endTime) {
				this.startTime = startTime;
				this.endTime = endTime;
			}
		},
		handleDropdownChange(type, val) {
			const callingFunction = this.showDialog
				? this.getRetailerVisitHistory
				: this.fetchAllRetailVisits;
			if (type === "tsm") {
				this.selectedTsm = val;
				this.currentUserId = val;
				this.selectedDse = "";
				callingFunction(val);
			} else if (type === "dse") {
				this.selectedDse = val;
				this.currentUserId = val;
				callingFunction(val);
			} else {
				this.dateOption = val;
				if (val !== "Custom")
					callingFunction(
						this.showDialog
							? this.selectedShop.userId
							: this.currentUserId
					);
				else this.setStartEndDate();
			}
		},
		changeOffset(updateValue) {
			if (updateValue === "inc") this.offset += this.limit;
			else this.offset -= this.limit;
			this.showDialog
				? this.getRetailerVisitHistory(this.selectedShop.userId)
				: this.fetchAllRetailVisits(this.currentUserId);
		},
		goBack() {
			this.processStep--;
			if (!this.processStep) {
				this.showDialog = false;
				this.defaultSelection();
				this.fetchAllRetailVisits(this.userId);
			}
		},
		openPopup(item) {
			this.selectedShop = item;
			this.showDialog = true;
			this.processStep = 1;
			this.defaultSelection();
			this.getRetailerVisitHistory(item.userId);
		},
		defaultSelection() {
			this.dateOption = this.selectDateOptions[0];
			this.limit = 100;
			this.offset = 0;
		},
		handleTimeChange(isStartTime, val) {
			isStartTime ? (this.startTime = val) : (this.endTime = val);
			console.log("s", this.startTime);
			this.showDialog
				? this.getRetailerVisitHistory(
						this.selectedShop.userId,
						this.startTime,
						this.endTime
				  )
				: this.fetchAllRetailVisits(
						this.currentUserId,
						this.startTime,
						this.endTime
				  );
		},
		showRetail(item) {
			this.retailerData = item;
			this.processStep++;
		},
		downloadPdf() {
			__fileDownload(
				this.retailerData.addressProof
					? this.retailerData.addressProof[0].url
					: ""
			);
		},
		openGoogleMap(action) {
			if (window.ReactNativeWebView) {
				window.ReactNativeWebView.postMessage(
					JSON.stringify({
						openExternalLink: { action }
					})
				);
			} else {
				window.open(action, "_blank");
			}
		}
	}
};
</script>

<style scoped>
.container {
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-top: 65px;
}
.proofDocument {
	font-weight: 400;
	font-size: 16px;
	color: #00000073;
}
.pdfCard {
	background: #fafafa;
	margin: 1rem 0rem;
	padding: 10px 20px;
}
.addressBox {
	background: rgb(245, 245, 245);
	width: 100%;
	padding: 0.5rem;
	display: flex;
	flex-direction: column;
}
.alignInColumn {
	display: flex;
	flex-direction: column;
}
.imageSize {
	min-width: 300px;
	height: 300px;
}
</style>
